import React from 'react';
import { Link } from 'react-router-dom';
import HeaderThree from '../../common/header/HeaderThree';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import ContactFormTwo from '../../elements/ContactFormTwo';
import ContactInfo from '../../elements/ContactInfo';
import Map from '../../elements/Map';
import AwardTwo from '../../components/section-components/AwardTwo';
import OurAttorneysThree from '../../components/section-components/OurAttorneysThree';
import Counter from '../../components/section-components/Counter';
import FooterThree from '../../common/footer/FooterThree';

const ContactUsTwo = () => {
    return (
        <>
        <HeaderThree />

        <BreadcrumbOne 
            title="Contact Us 2"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Contact Us 2"
        />
        
        {/*Contact Section*/}
        <section className="contact-section section-padding-default">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-4">
                <div className="contact-number mb-5">
                    <i className="fa fa-phone" />
                    <span><a href="tel:youremail@domain.com">+01726903999</a></span>
                </div>
                </div>
                <div className="col-lg-4">
                <div className="contact-email mb-5">
                    <i className="fa fa-envelope" />
                    <span><a href="mailto:youremail@domain.com">youremail@domain.com</a></span>
                </div>
                </div>
                <div className="col-lg-4">
                <div className="contact-support mb-5">
                    <i className="fa fa-paper-plane" />
                    <span>Get Free Support 24/7</span>
                </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="row clearfix">
                    <div className="col-lg-6">
                    <div className="con-contact-form">
                        <ContactFormTwo />
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="cont-contact-details">
                        <ContactInfo />
                        <Map />
                        <div className="contact-social mt-3">
                        <div className="contact-sociallink">
                            <span className="title">share :</span>
                            <Link to="#" className="blog-det-social">
                            <i className="fa fa-facebook" />
                            </Link>
                            <Link to="#" className="blog-det-social">
                            <i className="fa fa-linkedin" />
                            </Link>
                            <Link to="#" className="blog-det-social">
                            <i className="fa fa-instagram" />
                            </Link>
                            <Link to="#" className="blog-det-social">
                            <i className="fa fa-pinterest-p" />
                            </Link>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Contact Section*/}
        

        <AwardTwo /> 
        
        <OurAttorneysThree />
        
        <Counter />

        <FooterThree />
        </>
    )
}
    
export default ContactUsTwo;